<template>
  <div class="page">
    <my-header :breadcrumb="breadcrumb"></my-header>
    <div class="content">
      <div class="content-wrap">
        <!--搜索-->
        <el-button type="primary" @click="clickAdd">添加广告</el-button>
        <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
          <el-form :model="form">
            <el-form-item label="广告位名称" :label-width="formLabelWidth">
              <el-select v-model="form.position_name" placeholder="请选择" @change="selectChange">
                <el-option
                  v-for="item in options"
                  :key="item.position_id"
                  :label="item.position_name"
                  :value="item.position_id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="广告名称" :label-width="formLabelWidth">
              <el-input v-model="form.ad_name"></el-input>
            </el-form-item>
            <el-form-item label="图片" prop="ad_code" :label-width="formLabelWidth">
              <el-upload
                class="avatar-uploader"
                :action="uploadUrl" :headers="headers" :with-credentials="true"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="imageUrl" :src="imageUrl" class="avatar" v-model="form.store_logo">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="clickConfirm">确 定</el-button>
          </div>
        </el-dialog>
        <!-- 工具栏（列表名称、列表显示项设置） -->
        <!--列表内容-->

        <el-table
          :data="tableData"
          style="width: 100%;margin:10px 0 0 0;"
          row-key="cate_id"
          default-expand-all
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          :default-sort="{prop: 'nav_id', order: 'ascending'}"
        >

          <el-table-column
            prop="ad_name"
            label="广告名称"
            sortable
          >
          </el-table-column>


          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)">编辑
              </el-button>
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="totalCount" :page-size="20" class="page-wrap" @current-change="currentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import MyHeader from "../header";
  import Cookies from "js-cookie"
  export default {
    name: "list",
    components: {
      MyHeader
    },
    data() {
      return {
        form: {
          parentName:'',
          typeName:'',
          moduleName:'',
          site_id:0,
          position_name:''
        },
        formLabelWidth:'120px',
        tableData: [],
        totalCount: 0,
        pageCount: 1,
        breadcrumb: [
          {
            name: '网站导航'
          },
          {
            name: '导航列表'
          }
        ],
        dialogFormVisible:false,
        arrType:[
          {label:'内部模块',value:1},
          {label:'外部链接',value:2}
        ],
        arrModule:[
          {label:'文章模块',value:1}
        ],
        showModule:false,
        showLink:false,
        dialogTitle:'添加广告',
        categoryList:[],
        parentList:[],
        options:[],
        imageUrl:'',
        uploadUrl:this.apiUrl+'/v1/upload/upload',
        headers:{
          Authorization:'Bearer '+Cookies.get('access_token')
        }
      }
    },
    created(){
      this.form.nav_id = this.$route.query.id;
      this.$http.get(this.apiUrl+'/v1/ad/list',{params:{site_id:Cookies.get('siteId')}}).then((res)=>{
        //console.log(res)
        this.tableData = res.data.result.list;
        this.totalCount = parseInt(res.data.result.totalCount);
      })
      this.$http.get(this.apiUrl+'/v1/ad-position/list',{params:{site_id:Cookies.get('siteId')}}).then((res)=>{
        //console.log(res)
        this.options = res.data.result.list;
      })
    },
    methods:{
      clickAdd(){
        this.dialogFormVisible = true;
        this.form  = {};
      },
      clickConfirm(){
        this.form.ad_code = this.imageUrl;
        this.form.site_id = Cookies.get('siteId')
        this.$http.post('/v1/ad/save',this.form).then(({data})=>{
          if (data.errcode == 0){
            this.$message.success(data.msg);
            this.dialogFormVisible = false;
            this.$http.get(this.apiUrl+'/v1/ad/index',{params:{site_id:Cookies.get('siteId')}}).then((res)=>{
              this.tableData = res.data;
              this.totalCount = parseInt(res.headers['x-pagination-total-count']);
            })
          }else{
            this.$message.error(data.msg);
          }
        })
      },
      handleEdit(index,row){
        var _this = this;
        this.dialogFormVisible = true;
        this.dialogTitle = '修改广告';
        this.$http.get('/v1/ad/view?id='+row.ad_id).then(({data})=>{
          this.form = data;
          //console.log(this.form);
          //console.log(this.options)
          this.options.forEach(function (item) {
            //_this.form.position_name = item.position_name
            _this.$set(_this.form,'position_name',item.position_name);
          })
          this.imageUrl = data.result.ad_code;
        })
      },
      handleDelete(index,row){
        this.$http.delete('/v1/ad/delete',{data:{id:row.ad_id}}).then(({data})=>{
          if (data.errcode == 0){
            this.$message.success(data.msg);
            this.$http.get('/v1/ad/list',{params:{site_id:Cookies.get('siteId')}}).then(({data})=>{
              this.tableData = data.result.list;
              this.totalCount = parseInt(data.result.totalCount);
            })
          }else{
            this.$message.error(data.msg)
          }
        })
      },
      changeType(val){
        this.form.type = val;
        if (val == 1){
          this.showModule = true;
          this.showLink = false;

        }else {
          this.showLink = true;
          this.showModule = false;
          this.form.module_id = 0;
        }
      },
      changeModule(val){
        this.form.module_id = val;
        if (val == 1){
          this.$http.get('/v1/acategory/list?siteId='+Cookies.get('siteId')).then(({data}) => {
            this.categoryList = data.result;
          })
        }

      },
      changeCate(val){
        var _this = this;
        this.form.category_id = val;
        if (!this.form.nav_id){
          this.categoryList.forEach(function (item) {
            if(item.cate_id == val){
              _this.form.title =  item.cate_name;
            }
          })
        }

      },
      changeParent(val){
        var _this = this;
        this.form.parent_id  = val;
        this.tableData.forEach(function (item) {
          if (item.cate_id == val){
            _this.form.parentName = item.cate_name;
          }
        })
      },
      currentChange(currentPage){
        this.$http.get(this.apiUrl+'/v1/ad/index',{params:{site_id:Cookies.get('siteId'),page:currentPage}}).then((res)=>{
          //console.log(res)
          this.tableData = res.data;
          this.totalCount = parseInt(res.headers['x-pagination-total-count']);
        })
      },
      handleAvatarSuccess(res, file) {
        this.imageUrl = res.imgUrl;
        this.form.ad_code = res.imgUrl;
      },
      beforeAvatarUpload(file) {
        const isJPG = (file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif');
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传图片只能是图片格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      selectChange(val){
        this.form.position_id = val;
      }
    }
  }
</script>

<style scoped>
  .page-wrap{
    float: right;
    margin:30px 0 0 0;
  }
  .avatar-uploader >>> .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
